
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line',
      color: 'text-green-600 bg-green-100'
    },
    {
      name: 'UL Listed',
      description: 'Underwriters Laboratories Certified',
      icon: 'ri-award-line',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      name: 'NFPA',
      description: 'National Fire Protection Association Standards',
      icon: 'ri-fire-line',
      color: 'text-red-600 bg-red-100'
    },
    {
      name: 'BS Standards',
      description: 'British Standards Compliant',
      icon: 'ri-medal-line',
      color: 'text-purple-600 bg-purple-100'
    }
  ];

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">
            Compliance & Approvals
          </h2>
          <p className="text-gray-300 mb-12 text-lg">
            All FlameGuardQA fire protection products are certified and conform to international safety standards, 
            ensuring reliability and compliance with Qatar's fire safety regulations.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 text-center hover:transform hover:scale-105 transition-all duration-300"
              >
                <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${cert.color}`}>
                  <i className={`${cert.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{cert.name}</h3>
                <p className="text-gray-600 text-sm">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
